import type { FaireProductEntity } from "../../entity_types/product";

export const p_b28rg3e35s: FaireProductEntity = {
  token: "p_b28rg3e35s",
  type: "product",
  name: "Freestyle 2.0 Swim Diapers - NEW PRINTS!",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/46a529570b744e111ea5368eadb3bc692947ea6a61411b37494b64e28d80b4f8.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/84ccf030401640825710884b720496c54ac16c48930a7f950598647827e4d568.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
